import { getApiDomain } from '@/lib/curriculum-azure-functions'
import {
	FetchPrescriptionSelectionParams,
	PrescriptionSelectionResponse,
} from '@/types/fetchPrescriptionSelection'
import {
	FetchPrescriptionTextsParams,
	PrescriptionTextsResponse,
} from '@/types/fetchPrescriptionTexts'
import { commonFetch } from '@/utils/fetchUtils'

/**
 * Full List tab — `GET {DC_API_DOMAIN}/api/PrescriptionsList`.
 * Path comes from `NEXT_PUBLIC_DCAPI_PATH_PRESCRIPTION_LIST_LOAD` in `.env`.
 */
export const fetchPrescriptionList = async ({
	listcodename,
	search = '',
	prescriptionType = '',
	preview = false,
}: FetchPrescriptionTextsParams) => {
	const path = process.env.NEXT_PUBLIC_DCAPI_PATH_PRESCRIPTION_LIST_LOAD ?? ''
	const separator = path.includes('?') ? '&' : '?'
	const queryParts = [
		`listcodename=${encodeURIComponent(listcodename)}`,
		`search=${encodeURIComponent(search.trim())}`,
		`prescriptionType=${encodeURIComponent(prescriptionType)}`,
	]
	const url = `${getApiDomain(preview)}${path}${separator}${queryParts.join(
		'&',
	)}`
	return commonFetch<PrescriptionTextsResponse, undefined>(url, undefined, {
		method: 'GET',
	})
}

/**
 * Selection Tool tab — `GET {DC_API_DOMAIN}/api/PrescriptionsSelections`.
 * Path comes from `NEXT_PUBLIC_DCAPI_PATH_PRESCRIPTION_SELECTION_LOAD` in `.env`.
 */
export const fetchPrescriptionSelection = async ({
	listcodename,
	preview = false,
}: FetchPrescriptionSelectionParams) => {
	const path =
		process.env.NEXT_PUBLIC_DCAPI_PATH_PRESCRIPTION_SELECTION_LOAD ?? ''
	const separator = path.includes('?') ? '&' : '?'
	const url = `${getApiDomain(
		preview,
	)}${path}${separator}listcodename=${encodeURIComponent(listcodename)}`
	return commonFetch<PrescriptionSelectionResponse, undefined>(
		url,
		undefined,
		{ method: 'GET' },
	)
}
